module.exports = __webpack_public_path__ + "img/Desk Stationeryd01.f10fde65.jpg";